import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MarketingLayout from './layouts/MarketingLayout';
import AppLayout from './layouts/AppLayout';
import HomePage from './pages/marketing/HomePage';
import FeaturesPage from './pages/marketing/FeaturesPage';
import PricingPage from './pages/marketing/PricingPage';
import SecurityPage from './pages/marketing/SecurityPage';
import DemoPage from './pages/marketing/DemoPage';
import LoginPage from './pages/marketing/LoginPage';
import DownloadPage from './pages/DownloadPage';
import DashboardPage from './pages/app/DashboardPage';
import MattersListPage from './pages/app/MattersListPage';
import MatterDetailPage from './pages/app/MatterDetailPage';
import LodgementPage from './pages/app/LodgementPage';
import DocumentsPage from './pages/app/DocumentsPage';
import TrustAccountingPage from './pages/app/TrustAccountingPage';
import AICopilotPage from './pages/app/AICopilotPage';
import PolicyPulsePage from './pages/app/PolicyPulsePage';
import MigrationIntelPage from './pages/app/MigrationIntelPage';
import PathwayAdvisorPage from './pages/app/PathwayAdvisorPage';
import QuestionsPage from './pages/app/QuestionsPage';
import LettersPage from './pages/app/LettersPage';
import EsignPage from './pages/app/EsignPage';
import TasksPage from './pages/app/TasksPage';
import TimeTrackingPage from './pages/app/TimeTrackingPage';
import ContactsPage from './pages/app/ContactsPage';
import QuotesPage from './pages/app/QuotesPage';
import ReportsLibraryPage from './pages/app/ReportsLibraryPage';
import ApplicantsPage from './pages/app/ApplicantsPage';
import IntakePage from './pages/app/IntakePage';
import PortalIntakePage from './pages/public/PortalIntakePage';
import { ReferrerLoginPage, ReferrerDashboardPage } from './pages/public/ReferrerPortalPage';
import { ApplicantLoginPage, ApplicantDashboardPage } from './pages/public/ApplicantPortalPage';
import VerifyEsignPage from './pages/public/VerifyEsignPage';
import ReportsPage from './pages/app/ReportsPage';
import SponsorsPage from './pages/app/SponsorsPage';
import TeamPage from './pages/app/TeamPage';
import SettingsPage from './pages/app/SettingsPage';
import AdminConsolePage from './pages/app/AdminConsolePage';
import ElodgeFleetPage from './pages/app/ElodgeFleetPage';
import AnalyticsPage from './pages/app/AnalyticsPage';
import VetassessListPage from './pages/app/VetassessListPage';
import VetassessDetailPage from './pages/app/VetassessDetailPage';
import PortalPage from './pages/portal/PortalPage';
import PortalQuestionnairePage from './pages/portal/PortalQuestionnairePage';
import MagicVerifyPage from './pages/portal/MagicVerifyPage';
import { PaymentSuccessPage, PaymentCancelPage } from './pages/portal/PaymentResultPages';
import './App.css';

const withMarketing = (el) => <MarketingLayout>{el}</MarketingLayout>;
const withApp = (el) => <AppLayout>{el}</AppLayout>;

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={withMarketing(<HomePage />)} />
        <Route path="/features" element={withMarketing(<FeaturesPage />)} />
        <Route path="/pricing" element={withMarketing(<PricingPage />)} />
        <Route path="/security" element={withMarketing(<SecurityPage />)} />
        <Route path="/demo" element={withMarketing(<DemoPage />)} />
        <Route path="/login" element={withMarketing(<LoginPage />)} />
        <Route path="/prd" element={<DownloadPage />} />
        <Route path="/verify/:esignId" element={<VerifyEsignPage />} />
        <Route path="/app" element={withApp(<DashboardPage />)} />
        <Route path="/app/matters" element={withApp(<MattersListPage />)} />
        <Route path="/app/matters/:id" element={withApp(<MatterDetailPage />)} />
        <Route path="/app/lodgement" element={withApp(<LodgementPage />)} />
        <Route path="/app/documents" element={withApp(<DocumentsPage />)} />
        <Route path="/app/trust" element={withApp(<TrustAccountingPage />)} />
        <Route path="/app/copilot" element={withApp(<AICopilotPage />)} />
        <Route path="/app/vetassess" element={withApp(<VetassessListPage />)} />
        <Route path="/app/vetassess/:id" element={withApp(<VetassessDetailPage />)} />
        <Route path="/app/policy" element={withApp(<PolicyPulsePage />)} />
        <Route path="/app/intel" element={withApp(<MigrationIntelPage />)} />
        <Route path="/app/pathways" element={withApp(<PathwayAdvisorPage />)} />
        <Route path="/app/questions" element={withApp(<QuestionsPage />)} />
        <Route path="/app/letters" element={withApp(<LettersPage />)} />
        <Route path="/app/esign" element={withApp(<EsignPage />)} />
        <Route path="/app/tasks" element={withApp(<TasksPage />)} />
        <Route path="/app/time" element={withApp(<TimeTrackingPage />)} />
        <Route path="/app/contacts" element={withApp(<ContactsPage />)} />
        <Route path="/app/quotes" element={withApp(<QuotesPage />)} />
        <Route path="/app/reports/library" element={withApp(<ReportsLibraryPage />)} />
        <Route path="/app/applicants" element={withApp(<ApplicantsPage />)} />
        <Route path="/app/intake" element={withApp(<IntakePage />)} />
        <Route path="/portal/intake/:token" element={<PortalIntakePage />} />
        <Route path="/referrer" element={<ReferrerLoginPage />} />
        <Route path="/referrer/login" element={<ReferrerLoginPage />} />
        <Route path="/referrer/consume" element={<ReferrerLoginPage />} />
        <Route path="/referrer/dashboard" element={<ReferrerDashboardPage />} />
        <Route path="/applicant" element={<ApplicantLoginPage />} />
        <Route path="/applicant/login" element={<ApplicantLoginPage />} />
        <Route path="/applicant/consume" element={<ApplicantLoginPage />} />
        <Route path="/applicant/dashboard" element={<ApplicantDashboardPage />} />
        <Route path="/app/reports" element={withApp(<ReportsPage />)} />
        <Route path="/app/sponsors" element={withApp(<SponsorsPage />)} />
        <Route path="/app/team" element={withApp(<TeamPage />)} />
        <Route path="/app/analytics" element={withApp(<AnalyticsPage />)} />
        <Route path="/app/settings" element={withApp(<SettingsPage />)} />
        <Route path="/app/admin" element={withApp(<AdminConsolePage />)} />
        <Route path="/app/admin/elodge" element={withApp(<ElodgeFleetPage />)} />

        <Route path="/portal" element={<PortalPage />} />
        <Route path="/portal/questionnaire" element={<PortalQuestionnairePage />} />
        <Route path="/portal/magic" element={<MagicVerifyPage />} />
        <Route path="/portal/payment/success" element={<PaymentSuccessPage />} />
        <Route path="/portal/payment/cancel" element={<PaymentCancelPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
